document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initGaleriaProducto();
  initVariantesProducto();
  initParallax();
  initTiltCards();
  initComparador();
  initNewsletterPopup();
  initTraducirFiltros();
  initHeroSelector();
  initColorPreview();
});

function initHeroSelector() {
  var selector = document.querySelector('[data-mt-hero-selector]');
  if (!selector) return;
  var seccion = selector.closest('.mt-hero');
  if (!seccion) return;
  var imagen = seccion.querySelector('[data-mt-hero-img]');
  var cta = seccion.querySelector('[data-mt-hero-cta]');
  var botones = selector.querySelectorAll('[data-mt-hero-modo]');

  botones.forEach(function (boton) {
    boton.addEventListener('click', function () {
      var src = boton.getAttribute('data-imagen');
      var color = boton.getAttribute('data-color');
      var url = boton.getAttribute('data-url');

      botones.forEach(function (b) { b.classList.remove('is-activo'); });
      boton.classList.add('is-activo');

      if (color) seccion.style.setProperty('--mt-hero-acento', color);

      if (src && imagen) {
        imagen.style.opacity = '0';
        setTimeout(function () {
          imagen.src = src;
          imagen.style.opacity = '1';
        }, 260);
      }

      if (url && cta) cta.setAttribute('href', url);
    });
  });
}

function initColorPreview() {
  var widget = document.querySelector('[data-mt-color-preview]');
  if (!widget) return;
  var galeria = document.querySelector('[data-mt-galeria] .mt-producto__galeria-principal');
  if (!galeria) return;
  var swatches = widget.querySelectorAll('[data-mt-color-swatch]');
  if (!swatches.length) return;

  function aplicar(swatch) {
    galeria.style.setProperty('--mt-color-preview', swatch.getAttribute('data-mt-color-swatch'));
    galeria.classList.add('is-coloreada');
  }
  function restablecer() {
    var activo = widget.querySelector('.is-activo');
    if (activo) { aplicar(activo); return; }
    galeria.classList.remove('is-coloreada');
  }

  swatches.forEach(function (swatch) {
    swatch.addEventListener('mouseenter', function () { aplicar(swatch); });
    swatch.addEventListener('focus', function () { aplicar(swatch); });
    swatch.addEventListener('click', function () {
      swatches.forEach(function (s) { s.classList.remove('is-activo'); });
      swatch.classList.add('is-activo');
      aplicar(swatch);
    });
  });
  widget.addEventListener('mouseleave', restablecer);
}

function initTraducirFiltros() {
  var mapa = { Availability: 'Disponibilidad', Price: 'Precio' };

  function traducirNodo(nodo) {
    if (!nodo || nodo.nodeType !== 3) return;
    var texto = nodo.textContent.trim();
    if (mapa[texto]) nodo.textContent = nodo.textContent.replace(texto, mapa[texto]);
  }

  document.querySelectorAll('.facets__summary-label').forEach(function (etiqueta) {
    traducirNodo(etiqueta.childNodes[0]);
    var summary = etiqueta.closest('summary');
    if (summary) {
      Object.keys(mapa).forEach(function (en) {
        var aria = summary.getAttribute('aria-label');
        if (aria && aria.indexOf(en) === 0) {
          summary.setAttribute('aria-label', aria.replace(en, mapa[en]));
        }
      });
    }
  });

  document.querySelectorAll('.mobile-facets__summary > div > span:first-child').forEach(function (span) {
    traducirNodo(span.childNodes[0]);
  });
}

function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });

  // Red de seguridad: si por lo que sea el observer nunca dispara
  // (pestaña en segundo plano, navegador antiguo...), el contenido no debe
  // quedarse invisible para siempre.
  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
  }, 2500);
}

function initGaleriaProducto() {
  var wrap = document.querySelector('[data-mt-galeria]');
  if (!wrap) return;
  var principal = wrap.querySelector('[data-mt-galeria-principal]');
  var minis = wrap.querySelectorAll('[data-mt-galeria-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      if (!src) return;
      principal.src = src;
      minis.forEach(function (m) { m.classList.remove('is-activa'); });
      mini.classList.add('is-activa');
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-mt-form-producto]');
  if (!form) return;
  var dataEl = form.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var selects = form.querySelectorAll('[data-mt-opcion]');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = form.querySelector('[data-mt-precio]');
  var compareEl = form.querySelector('[data-mt-precio-comparado]');
  var botonEl = form.querySelector('[data-mt-boton-comprar]');

  function moneda(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
    });
  }

  function actualizar() {
    var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = moneda(variante.price);
    if (compareEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        compareEl.textContent = moneda(variante.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (botonEl) {
      var botonSpan = botonEl.querySelector('span');
      if (variante.available) {
        botonEl.disabled = false;
        botonEl.removeAttribute('aria-disabled');
        if (botonSpan) botonSpan.textContent = botonEl.getAttribute('data-texto-disponible');
      } else {
        botonEl.disabled = true;
        if (botonSpan) botonSpan.textContent = botonEl.getAttribute('data-texto-agotado');
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function initParallax() {
  var medios = document.querySelectorAll('.mt-hero__media, .mt-cierre__media');
  if (!medios.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;
  function actualizar() {
    medios.forEach(function (media) {
      var seccion = media.closest('.mt-hero, .mt-cierre');
      if (!seccion) return;
      var rect = seccion.getBoundingClientRect();
      var centro = rect.top + rect.height / 2 - window.innerHeight / 2;
      var desplazamiento = centro * -0.08;
      desplazamiento = Math.max(-40, Math.min(40, desplazamiento));
      media.style.transform = 'translateY(' + desplazamiento + 'px)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(actualizar);
      ticking = true;
    }
  }, { passive: true });
  actualizar();
}

function initNewsletterPopup() {
  var overlay = document.querySelector('[data-mt-popup-overlay]');
  if (!overlay) return;
  var CLAVE = 'mt-popup-visto';

  function abrir() {
    overlay.classList.add('is-visible');
    document.body.style.paddingBottom = overlay.offsetHeight + 'px';
  }
  function cerrar() {
    overlay.classList.remove('is-visible');
    document.body.style.paddingBottom = '';
    try { localStorage.setItem(CLAVE, '1'); } catch (e) {}
  }

  overlay.querySelectorAll('[data-mt-popup-cerrar]').forEach(function (btn) {
    btn.addEventListener('click', cerrar);
  });
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) cerrar();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-visible')) cerrar();
  });

  if (overlay.getAttribute('data-mt-popup-forzar') === 'true') {
    try { localStorage.setItem(CLAVE, '1'); } catch (e) {}
    abrir();
    return;
  }

  var yaVisto = false;
  try { yaVisto = localStorage.getItem(CLAVE) === '1'; } catch (e) {}
  if (yaVisto) return;

  var retraso = parseFloat(overlay.getAttribute('data-mt-popup-retraso') || '4') * 1000;
  setTimeout(abrir, retraso);

  window.addEventListener('resize', function () {
    if (overlay.classList.contains('is-visible')) {
      document.body.style.paddingBottom = overlay.offsetHeight + 'px';
    }
  });
}

function initComparador() {
  var cajas = document.querySelectorAll('[data-mt-comparador]');
  if (!cajas.length) return;
  cajas.forEach(function (caja) {
    var range = caja.querySelector('[data-mt-comparador-range]');
    if (!range) return;
    range.addEventListener('input', function () {
      caja.style.setProperty('--pos', range.value + '%');
    });
  });
}

function initTiltCards() {
  var tarjetas = document.querySelectorAll('.mt-modo-card');
  if (!tarjetas.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;

  tarjetas.forEach(function (tarjeta) {
    tarjeta.addEventListener('mousemove', function (e) {
      var rect = tarjeta.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      var rotY = x * 10;
      var rotX = y * -10;
      tarjeta.style.transform = 'perspective(900px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg) translateY(-8px)';
    });
    tarjeta.addEventListener('mouseleave', function () {
      tarjeta.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg) translateY(0)';
    });
  });
}
